var map = {
	"./en/king_card_1.png": "Hi5J",
	"./es/king_card_1.png": "qpze",
	"./pt/king_card_1.png": "AkN2"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Z/mR";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/.*\/king_card_1\.png$
// module id = Z/mR
// module chunks = 0